import { useEffect, useState } from "react";

export default function MobileNav(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("header");

  const closeMenu = () => setIsOpen(false);

  // YE SAB SE IMPORTANT FIX HAI - body pe class lagani hai
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("mobile-nav-active");
    } else {
      document.body.classList.remove("mobile-nav-active");
    }
    return () => document.body.classList.remove("mobile-nav-active");
  }, [isOpen]);

  const handleLinkClick = (menu) => {
    setActiveMenu(menu);
    closeMenu();
  };

  return (
    <>
      <button
        type="button"
        className="mobile-nav-toggle d-lg-none"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle navigation"
      >
        <i className={isOpen? "icofont-close" : "icofont-navigation-menu"}></i>
      </button>

      {isOpen && (
        <div className="mobile-nav-overly" onClick={closeMenu}></div>
      )}

      <nav className="mobile-nav">
        <ul>
          <li className={activeMenu === "header"? "active" : ""}>
            <a href="#header" onClick={() => handleLinkClick("header")}>Home</a>
          </li>
          <li className={activeMenu === "cotton"? "active" : ""}>
            <a href="#cotton" onClick={() => handleLinkClick("cotton")}>Cotton</a>
          </li>
          <li className={activeMenu === "sugar"? "active" : ""}>
            <a href="#sugar" onClick={() => handleLinkClick("sugar")}>Sugar</a>
          </li>
          <li className={activeMenu === "about"? "active" : ""}>
            <a href="#about" onClick={() => handleLinkClick("about")}>{props.aboutText || "About Us"}</a>
          </li>
          <li className={activeMenu === "contact"? "active" : ""}>
            <a href="#contact" onClick={() => handleLinkClick("contact")}>{props.contactText || "Contact Us"}</a>
          </li>
        </ul>
      </nav>
    </>
  );
}